import React from 'react';
import jquery from "jquery";

class Toast extends React.Component{

    static defaultProps = {
        title: "Toast",
        label: "",
        message: "An informational feedback message goes here.",
        autohide: false
    };
    
    componentDidMount() {
      jquery(this.refs.myToast).toast("show");
    }
    
    render(){
        const { title, label, message, autohide } = this.props;
        return (
            <div className={'fade toast'} role="alert" ref="myToast" data-autohide={autohide}>
              <div className="toast-header">
                <strong className="mr-auto">{title}</strong>
                <small>{label}</small>
                <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="toast-body">
                {message}
              </div>
            </div>
        );
    }
}

export default Toast;
